import { ProgressBar } from '@plush-book/ui';

const STEPS = ['Geschichte', 'Kuscheltier', 'Persönliches', 'Vorschau', 'Bestellung'];

export function StepHeader({ active }: { active: number }) {
  return (
    <>
      <DesktopRail active={active} />
      <div className="mobile-only">
        <ProgressBar steps={STEPS} active={active} />
      </div>
      <style>{`
        .mobile-only { display: block; }
        .desktop-rail { display: none; }
        @media (min-width: 1024px) {
          .mobile-only { display: none; }
          .desktop-rail { display: flex; }
        }
      `}</style>
    </>
  );
}

function DesktopRail({ active }: { active: number }) {
  return (
    <div
      className="desktop-rail"
      style={{
        alignItems: 'center',
        gap: 0,
        padding: '20px 36px',
        background: 'var(--bg-card)',
        borderBottom: '1px solid var(--line-soft)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--terracotta)',
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            fontFamily: 'var(--serif)',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          k
        </div>
        <span style={{ fontFamily: 'var(--serif)', fontSize: 16, fontWeight: 500 }}>
          Kuscheltier Buch
        </span>
      </div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: 0 }}>
        {STEPS.map((l, i) => {
          const done = i < active;
          const on = i === active;
          return (
            <div key={l} style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: 999,
                    background: done
                      ? 'var(--sage-deep)'
                      : on
                        ? 'var(--terracotta)'
                        : 'var(--bg)',
                    color: done || on ? '#fff' : 'var(--ink-mute)',
                    display: 'grid',
                    placeItems: 'center',
                    fontSize: 12,
                    fontWeight: 700,
                    border: !done && !on ? '1.5px solid var(--line)' : 'none',
                  }}
                >
                  {done ? '✓' : i + 1}
                </div>
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: on ? 700 : 500,
                    color: on
                      ? 'var(--ink)'
                      : done
                        ? 'var(--ink-soft)'
                        : 'var(--ink-mute)',
                  }}
                >
                  {l}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <div
                  style={{
                    width: 36,
                    height: 1,
                    background: done ? 'var(--sage-deep)' : 'var(--line)',
                    margin: '0 14px',
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, fontSize: 12, color: 'var(--ink-mute)' }}>
        <span>💾 Automatisch gespeichert</span>
      </div>
    </div>
  );
}
